import React, { PropTypes } from 'react';
import classNames from 'classnames';
import SubMenu from './SubMenu';
import MenuItem from './MenuItem';
import CSSTransitionGroup from 'react-addons-css-transition-group';

const Menu =
({ subitems, menuindex, items, lang, navOnly, backHome, showSection, backHomeLabel }) => (
  <div style={{ display: 'inline' }}>
    <p onClick={backHome} className={classNames('backhome', { appear: !navOnly })}>
      <span>{backHomeLabel}</span>
    </p>
    <div className="mainnavcontainer">
      <ul style={{ margin: `-${menuindex * 30}px 0 0 0` }} className="navitems">
        <CSSTransitionGroup
          transitionName="menuitem"
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={500}
          transitionAppear
        >
        {items.map((menuitem, i) =>
          <MenuItem
            className="menuitem"
            key={i}
            lang={lang}
            item={menuitem}
            onClick={showSection}
          />)}
        </CSSTransitionGroup>
      </ul>
    </div>
    <div className="underlinemainnav" />
    <SubMenu items={subitems} lang={lang} onClick={showSection} navOnly={navOnly} />
  </div>
);

Menu.propTypes = {
  items: PropTypes.object.isRequired,
  subitems: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  navOnly: PropTypes.bool.isRequired,
  menuindex: PropTypes.number.isRequired,
  backHome: PropTypes.func.isRequired,
  backHomeLabel: PropTypes.string.isRequired,
  showSection: PropTypes.func.isRequired,
};

export default Menu;



// WEBPACK FOOTER //
// ./common/components/Menu.js